module.exports = __webpack_public_path__ + "static/hymots-d-1-1366aa383d11b240f833e3a951d4c6ec.png";